export default "__VITE_ASSET__BQxJoOJD__"